import { useCallback, useState } from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import { EmbeddedLayout } from "../components/EmbeddedLayout";
import { FlowAddPayoutMethod } from "../../Settings/components/payout/FlowAddPayoutMethod";
import { ManagePayoutMethod } from "../../Settings/components/payout/ManagePayoutMethod";
import { WSServiceError } from "../../../utils/serviceHelper";
import {
  PATH_EMBEDDED_MANAGE_PAYOUT_METHOD,
  PATH_EMBEDDED_MANAGE_PAYOUT_METHOD_ADD
} from "../paths";
import {
  parseAllowedInternationalPayoutMethods,
  parseAllowedUsPayoutMethods
} from "../utils/parseAllowedPayoutMethods";
import { sendMessageToParent } from "../utils/postMessage";

export const RouteManagePayoutMethod: React.FC = () => {
  const history = useHistory();
  const location = useLocation<{ error?: WSServiceError }>();

  const [payoutMethodConfig] = useState(() => {
    const params = new URLSearchParams(location.search);
    const allowedUsMethods = parseAllowedUsPayoutMethods(
      params.get("allowedUsMethods") || ""
    );
    const allowedInternationalMethods = parseAllowedInternationalPayoutMethods(
      params.get("allowedInternationalMethods") || ""
    );
    const localCurrencyOnly = params.get("localCurrencyOnly") === "true";
    const fallbackCurrency = params.get("fallbackCurrency") || undefined;
    // When the integrator pins a country, lock the country selector in the
    // manual account form so it can't be changed.
    const lockCountry = !!params.get("country");
    // Empty arrays mean "no restriction" — pass undefined so
    // FlowAddPayoutMethod falls through to its default behavior
    // (show every available method).
    return {
      allowedUsMethods:
        allowedUsMethods.length > 0 ? allowedUsMethods : undefined,
      allowedInternationalMethods:
        allowedInternationalMethods.length > 0
          ? allowedInternationalMethods
          : undefined,
      localCurrencyOnly,
      fallbackCurrency,
      lockCountry
    };
  });

  const goBackToManage = useCallback(() => {
    history.push({
      pathname: PATH_EMBEDDED_MANAGE_PAYOUT_METHOD,
      search: location.search
    });
  }, [history, location.search]);

  return (
    <EmbeddedLayout>
      <Switch>
        <Route path={PATH_EMBEDDED_MANAGE_PAYOUT_METHOD_ADD}>
          <FlowAddPayoutMethod
            basePath={PATH_EMBEDDED_MANAGE_PAYOUT_METHOD_ADD}
            availableUsMethods={payoutMethodConfig.allowedUsMethods}
            availableInternationalMethods={
              payoutMethodConfig.allowedInternationalMethods
            }
            localCurrencyOnly={payoutMethodConfig.localCurrencyOnly}
            fallbackCurrency={payoutMethodConfig.fallbackCurrency}
            lockCountry={payoutMethodConfig.lockCountry}
            onBack={goBackToManage}
            onNext={goBackToManage}
            onError={error => {
              history.push({
                pathname: PATH_EMBEDDED_MANAGE_PAYOUT_METHOD,
                search: location.search,
                state: { error }
              });
            }}
          />
        </Route>

        <Route path={PATH_EMBEDDED_MANAGE_PAYOUT_METHOD}>
          <ManagePayoutMethod
            onSaved={() => sendMessageToParent("complete", { changed: true })}
            onAddNew={() => {
              history.push({
                pathname: PATH_EMBEDDED_MANAGE_PAYOUT_METHOD_ADD,
                search: location.search
              });
            }}
            error={location.state?.error}
          />
        </Route>
      </Switch>
    </EmbeddedLayout>
  );
};
